import {PayloadAction, createSlice} from '@reduxjs/toolkit';
interface IEditImageProfile {
  imageFile: React.ChangeEvent<HTMLInputElement> | null;
  cropedImage: File | null;
}
interface IImage {
  imageFile: React.ChangeEvent<HTMLInputElement> | null;
}
const initialState: IEditImageProfile = {
  imageFile: null,
  cropedImage: null,
};

export const editImageProfile = createSlice({
  name: 'imageProfile',

  initialState,
  reducers: {
    addingImage: (state, action: PayloadAction<IImage>) => {
      state.imageFile = action.payload.imageFile;
    },
    addingCropedImage: (state, action: PayloadAction<File>) => {
      
      state.cropedImage = action.payload;
    },
    clearImage: state => {
      state.imageFile = null;
    },
    clearAllData: state => {
      state.imageFile = null;
      state.cropedImage = null;
    },
  },
});
export const {addingImage, clearAllData, clearImage, addingCropedImage} =
  editImageProfile.actions;

export default editImageProfile.reducer;
